<template>
  <div>
    <v-select
      label="Gymnasisereform"
      :items="reforms"
      outlined
      v-model="selectedReform"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'TheReformSelect',

  props: {
    reform: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    reforms: ['Gy11', 'Gy25'],
  }),

  computed: {
    selectedReform: {
      get() {
        return this.reform
      },
      set(value) {
        this.$emit('selected-reform', value)
      }
    }
  }
}
</script>

<style>

</style>